import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import ProgressBar from '../../components/ProgressBar/progressbar';
import { usePatchForm } from '../../providers/PatchFormProvider';
import Styles from './patchcenterStyle.module.scss';

import { useNavigate } from 'react-router-dom';
import SoftwareTable from './softwareTable';

const AvailablePatch = () => {
  const navigate = useNavigate();
  const { patchFormData, setPatchFormData } = usePatchForm();
  const [patchList, setPatchList] = useState(patchFormData.RemediationPlanPatchList || []);
  const [selectedCount, setSelectedCount] = useState(0);

  const handleCountChange = (_osCount: number, thirdPartyCount: number) => {
    setSelectedCount(thirdPartyCount);
  };

  const handleCancelBtn = () => {
    navigate('/patchCenter');
  };

  const handleNextBtn = () => {
    setPatchFormData((prev) => ({
      ...prev,
      RemediationPlanPatchList: patchList,
    }));
    navigate('/patchCenter/OSUpdatePatch');
  };

  const handlePrevious = () => {
    navigate('/patchCenter/deviceSelect');
  };

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#161617)] flex-1">
        <Header title="Patches Available" dropdown={2} />

        <Card className="flex-1">
          <div className={`${Styles.progressBar} items-center justify-between mb-5`} style={{ marginLeft: '0px' }}>
            <ProgressBar stepNum={2} identity={'Device select'} />
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '20px',
            }}
          >
            <span
              style={{
                fontSize: '14px',
                fontWeight: '500',
                color: '#9CA3AF',
                letterSpacing: '0.5px',
              }}
            >
              Selected:
            </span>
            <span
              style={{
                fontSize: '18px',
                fontWeight: '700',
                color: '#EF4444',
                backgroundColor: 'rgba(239, 68, 68, 0.15)',
                padding: '6px 14px',
                borderRadius: '6px',
                border: '1px solid rgba(239, 68, 68, 0.3)',
                marginLeft: 8,
              }}
            >
              {selectedCount}
            </span>
          </div>

          <div>
            <SoftwareTable setPatchList={setPatchList} softwarePatchType="ThirdPartySoftware" onCountChange={handleCountChange} />
          </div>

          <div className="mt-6 flex justify-end space-x-2.5">
            <button className="w-32 px-6 py-2 border border-gray-500 rounded-[30px] hover:bg-gray-700" onClick={handleCancelBtn}>
              Cancel
            </button>
            <button className="w-42 px-6 py-2 border border-gray-500 rounded-[30px] hover:bg-gray-700" onClick={handlePrevious}>
              Previous
            </button>
            <button className="w-32 px-6 py-2 bg-red-600 rounded-[30px] shadow-md hover:bg-red-700" onClick={handleNextBtn}>
              Next
            </button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AvailablePatch;
